import {
    PAYMENT_DETAILS_SHARE_VIA_EMAIL_REQUEST,
    PAYMENT_DETAILS_SHARE_VIA_EMAIL_SUCCESS,
    PAYMENT_DETAILS_SHARE_VIA_EMAIL_ERROR
  } from "./PaymentShareViaEmailTypes";
  
  const initialState = {
    loading: false,
    isSubmitted: false,
    successMessage: "",
    errorMessage: "",
    paymentDetails: []
  };
  
  export default (state = initialState, action) => {
    switch (action.type) {
      case PAYMENT_DETAILS_SHARE_VIA_EMAIL_REQUEST:
        return {
          ...state,
          isSubmitted: true,
          loading: true
        };
      case PAYMENT_DETAILS_SHARE_VIA_EMAIL_SUCCESS:
        // do something
        return {
          ...state,
          loading: false,
          isSubmitted: false,
          paymentDetails: action.payload,
          successMessage: "Email sent successfully!",
          errorMessage: ""
        };
      case PAYMENT_DETAILS_SHARE_VIA_EMAIL_ERROR:
        return {
          ...state,
          loading: false,
          isSubmitted: false,
          paymentDetails: [],
          errorMessage: action.payload
        };
      default:
        return state;
    }
  };
  